const compare = (message) => value => {
    return message ? message : undefined;
    return undefined;
  }
  
  export default compare;